import { initializer } from '../helpers/functions';
import { categories } from '../services/londi-constants';
import { screeningResultsState } from '../helpers/state';

export const competenceReducer = (state = initializer, action) => {
  switch (action.type) {
    case 'RESET_STATE':
      return screeningResultsState;
    case 'CLEAR_TEST_RESULTS':
      return {
        ...state,
        // Clear all test IDs and results
        readingTestId: null,
        writingTestId: null,
        countingTestId: null,
        readingSecondTestId: null,
        writingSecondTestId: null,
        countingSecondTestId: null,
        readingThirdTestId: null,
        writingThirdTestId: null,
        countingThirdTestId: null,
        resultsReading: null,
        resultsWriting: null,
        resultsCounting: null,
        resultsSecondReading: null,
        resultsSecondWriting: null,
        resultsSecondCounting: null,
        resultsThirdReading: null,
        resultsThirdWriting: null,
        resultsThirdCounting: null,
        // Clear self-assessment results as well since they come after tests
        readingK1Results: null,
        readingK2Results: null,
        readingK3Results: null,
        readingK4Results: null,
        writingK1Results: null,
        writingK2Results: null,
        writingK3Results: null,
        writingK4Results: null,
        countingK1Results: null,
        countingK2Results: null,
        countingK3Results: null,
        countingK4Results: null,
      };
    case 'CLEAR_SELF_ASSESSMENT':
      return {
        ...state,
        // Clear only self-assessment results
        readingK1Results: null,
        readingK2Results: null,
        readingK3Results: null,
        readingK4Results: null,
        writingK1Results: null,
        writingK2Results: null,
        writingK3Results: null,
        writingK4Results: null,
        countingK1Results: null,
        countingK2Results: null,
        countingK3Results: null,
        countingK4Results: null,
      };
    case 'readingK1Options':
      return { ...state, options: 'readingK1Options' };
    case 'readingK1':
      return {
        ...state,
        readingK1Results: {
          category: categories.Reading,
          result: action.payload,
        },
        options: '',
      };
    case 'readingK2Options':
      return { ...state, options: 'readingK2Options' };
    case 'readingK2':
      return {
        ...state,
        readingK2Results: {
          category: categories.Reading,
          result: action.payload,
        },
        options: '',
      };
    case 'readingK3Options':
      return { ...state, options: 'readingK3Options' };
    case 'readingK3':
      return {
        ...state,
        readingK3Results: {
          category: categories.Reading,
          result: action.payload,
        },
        options: '',
      };
    case 'readingK4Options':
      return { ...state, options: 'readingK4Options' };
    case 'readingK4':
      return {
        ...state,
        readingK4Results: {
          category: categories.Reading,
          result: action.payload,
        },
        options: '',
      };
    case 'writingK1Options':
      return { ...state, options: 'writingK1Options' };
    case 'writingK1':
      return {
        ...state,
        writingK1Results: {
          category: categories.Writing,
          result: action.payload,
        },
        options: '',
      };
    case 'writingK2Options':
      return { ...state, options: 'writingK2Options' };
    case 'writingK2':
      return {
        ...state,
        writingK2Results: {
          category: categories.Writing,
          result: action.payload,
        },
        options: '',
      };
    case 'writingK3Options':
      return { ...state, options: 'writingK3Options' };
    case 'writingK3':
      return {
        ...state,
        writingK3Results: {
          category: categories.Writing,
          result: action.payload,
        },
        options: '',
      };
    case 'writingK4Options':
      return { ...state, options: 'writingK4Options' };
    case 'writingK4':
      return {
        ...state,
        writingK4Results: {
          category: categories.Writing,
          result: action.payload,
        },
        options: '',
      };
    case 'countingK1Options':
      return { ...state, options: 'countingK1Options' };
    case 'countingK1':
      return {
        ...state,
        countingK1Results: {
          category: categories.Math,
          result: action.payload,
        },
        options: '',
      };
    case 'countingK2Options':
      return { ...state, options: 'countingK2Options' };
    case 'countingK2':
      return {
        ...state,
        countingK2Results: {
          category: categories.Math,
          result: action.payload,
        },
        options: '',
      };
    case 'countingK3Options':
      return { ...state, options: 'countingK3Options' };
    case 'countingK3':
      return {
        ...state,
        countingK3Results: {
          category: categories.Math,
          result: action.payload,
        },
        options: '',
      };
    case 'countingK4Options':
      return { ...state, options: 'countingK4Options' };
    case 'countingK4':
      return {
        ...state,
        countingK4Results: {
          category: categories.Math,
          result: action.payload,
        },
        options: '',
      };
    default:
      return state;
  }
};
